(function ($){
    const BODY = $('body');

    // add class for custom checkbox
    $('.woof input[type="checkbox"]')
        .wrap('<span class="custom-checkbox"></span>')
        .after('<i class="icon-check"></i>');

    $('.woof input[type="radio"]')
        .wrap('<span class="custom-radio"></span>')
        .after('<i></i>');
}(jQuery));
